"use client";
import styles from "./Banner.module.scss";
import Swiper from "components/common/Swiper";
import Image from "components/common/Image";

import cx from "classnames";
import { map, get, isString } from "utils/lodash";
import { useRouteContext } from "providers/RouteProvider";
const RenderBanner = (item: any) => {
  const { router } = useRouteContext();
  const deepLink = isString(get(item, "linkUrl")) ? get(item, "linkUrl") : "";
  return (
    <div
      onClick={() => {
        router.handleDeepLink(deepLink);
      }}
      className="w-full aspect-[375/70] cursor-pointer"
    >
      <Image
        wrapClassName="w-full aspect-[375/70]"
        src={get(item, "src") || get(item, "url") || item}
        alt={get(item, "alt") || "Banner"}
      />
    </div>
  );
};
const Banner = ({ data, banner = "" }: { data: any; banner?: string }) => {
  let images = [{ src: banner }];
  if (data) {
    images = map(get(data, "images"), (item) => ({
      ...item,
      src: get(item, "image.url"),
      alt: get(item, "altText") || get(item, "image.alt") || "",
    }));
  }

  return (
    <div className={cx("bg-white", styles.banner)}>
      <div className="container mx-auto p-2">
        {images && images.length > 0 && (
          <Swiper
            classNameSlide="w-full aspect-[375/70]"
            data={images}
            renderItem={RenderBanner}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
          />
        )}
      </div>
    </div>
  );
};

export default Banner;
